export default class BlockCardSlider {
	static init() {

		let blocks = document.querySelectorAll('.block-card-slider');

		blocks.forEach( (block) => {

			const swiperThumbnail = block.querySelector('.swiper-thumbnail');
			let thumbnail = new Swiper(swiperThumbnail, {
				slidesPerView: "auto",
				spaceBetween : 24
			});

			const swiperText = block.querySelector('.swiper-content');
			new Swiper(swiperText, {
				slidesPerView: 1,
				spaceBetween : 0,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: swiperThumbnail
				}
			});

		});
	}
}
